export default __webpack_public_path__ + "static/media/logo-appbis.c07ed8cf.svg";